import { useNavigate } from 'react-router-dom'
import { HStack, VStack, Text, useIsMobile, useIsTablet } from 'wss3-forge'

const footerLinks = [
  { label: 'Shop', href: 'https://murphy-workshop.com', external: true },
  { label: 'Support', href: '/support', external: false },
  { label: 'Discord', href: 'https://discord.gg/ZRABGm7we8', external: true }
]

export function DocsFooter() {
  const navigate = useNavigate()
  const isMobile = useIsMobile()
  const isTablet = useIsTablet()

  const handleClick = (link: typeof footerLinks[0]) => {
    if (link.external) {
      window.open(link.href, '_blank')
    } else {
      navigate(link.href)
    }
  }

  return (
    <footer
      style={{
        padding: isMobile ? '32px 0' : '40px 0',
        backgroundColor: '#171515',
        borderTop: '1px solid #1A1A1A'
      }}
    >
      <div className="page-content">
        {isMobile ? (
          <VStack gap="lg" style={{ alignItems: 'center' }}>
            <div
              className="clickable"
              onClick={() => navigate('/')}
            >
              <img
                src="/logo_murphy_white.svg"
                alt="Murphy's Workshop"
                style={{ height: '18px' }}
              />
            </div>

            <HStack gap="md" style={{ alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center' }}>
              {footerLinks.map((link) => (
                <span
                  key={link.label}
                  className="clickable link-underline-hover"
                  style={{
                    color: '#9CA3AF',
                    fontSize: '13px',
                    cursor: 'pointer'
                  }}
                  onClick={() => handleClick(link)}
                >
                  {link.label}
                </span>
              ))}
            </HStack>

            <Text size="sm" style={{ color: '#9CA3AF', textAlign: 'center', fontSize: '12px' }}>
              © {new Date().getFullYear()}{' '}
              <a
                href="https://webba-creative.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#9CA3AF', textDecoration: 'none' }}
                className="link-underline-hover"
              >
                Webba Creative Technologies
              </a>{' '}
              / Murphy's Workshop
            </Text>
          </VStack>
        ) : (
          <HStack
            gap={isTablet ? 'md' : 'lg'}
            style={{
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: 'wrap'
            }}
          >
            <div
              className="clickable"
              onClick={() => navigate('/')}
            >
              <img
                src="/logo_murphy_white.svg"
                alt="Murphy's Workshop"
                style={{ height: '18px' }}
              />
            </div>

            <HStack gap={isTablet ? 'md' : 'lg'} style={{ alignItems: 'center', flexWrap: 'wrap' }}>
              {footerLinks.map((link) => (
                <span
                  key={link.label}
                  className="clickable link-underline-hover"
                  style={{
                    color: '#9CA3AF',
                    fontSize: isTablet ? '13px' : '14px',
                    cursor: 'pointer'
                  }}
                  onClick={() => handleClick(link)}
                >
                  {link.label}
                </span>
              ))}
            </HStack>

            <Text size="sm" style={{ color: '#9CA3AF', fontSize: isTablet ? '13px' : '14px' }}>
              © {new Date().getFullYear()}{' '}
              <a
                href="https://webba-creative.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#9CA3AF', textDecoration: 'none' }}
                className="link-underline-hover"
              >
                Webba Creative Technologies
              </a>{' '}
              / Murphy's Workshop
            </Text>
          </HStack>
        )}
      </div>
    </footer>
  )
}
